import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import ConstElement from '../common/ConstElement';
import HasPermission from '../helper/user.js';
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class EditJobApply extends Component {
    constructor(props) {
        super(props);
        this.state = {
                jobApply: {},
                hasPermissionCancel:false,
                current_status: '',
                statusOptions: [],
                isFinishedEvaluation: false
        }
        this.saveData = this.saveData.bind(this);
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.destroyJobApply = this.destroyJobApply.bind(this);
        this.handleInptChange = this.handleInptChange.bind(this);
        this.cancelApplyJob = this.cancelApplyJob.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.getJobApplyById = this.getJobApplyById.bind(this);
        this.generateJobApplyStatus = this.generateJobApplyStatus.bind(this);
        this.renderApplyDates = this.renderApplyDates.bind(this);
    }

    /**
     * Init data
     */
    componentWillMount() {
        HasPermission('/api/jobapplys/delete').then(permission => {this.setState({hasPermissionCancel: permission})});

        if (this.props.match.params.hasOwnProperty('id')) {
            this.getJobApplyById();
        }
    }

    /**
     * Set data of jobApply
     * data: Object JobApply
     */
    getJobApplyById() {
        const jobId = this.props.match.params.id
        axios.get('/api/jobapplys/' + jobId).then(response => {
            let jobApply = response.data;
            if (jobApply['status'] == null) {
                jobApply['status'] = 'NULL';
            }

            // If job apply status is reject and job status is waiting evaluation
            // no need to change job apply status
            if (jobApply['status'] == 2 && jobApply['job_status'] == 4) {
                this.setState({isFinishedEvaluation: true});
            }

            // If finish eveluation no need to change job apply status
            if (!!(jobApply.evaluation_staff && jobApply.evaluation_client)) {
                this.setState({isFinishedEvaluation: true});
            }
            this.setData(jobApply);
            this.generateJobApplyStatus(jobApply);
            this.setState({current_status: response.data.status});
        }).catch(() => {
            this.props.history.push('/_404');
        })
    }

    /**
     * Set data of jobApply
     * data: Object JobApply
     */
    setData(data) {
        this.setState({
            jobApply: data
        })
    }

    /**
     * Get data of jobApply
     */
    getData() {
        return this.state.jobApply;
    }

    /**
     * Listen change input
     * event: Object input
     */
    handleInptChange(event) {
        let jobApplyData = Object.assign({}, this.state.jobApply);
        jobApplyData[event.target.name] = event.target.value;
        // if (event.target.name === 'status' && event.target.value == 3) {
        //     jobApplyData['evaluation_staff'] = 1;
        // }

        this.setState({jobApply: jobApplyData});
    }

    /**
     * Generate JobApply status option
     */
    generateJobApplyStatus(jobApply) {
        let options = [
            {value: 'NULL', label: '未決定', disabled: jobApply.disable_status.not_set},
            {value: 1, label: '採用', disabled: jobApply.disable_status.accepted},
            {value: 2, label: '不採用', disabled: jobApply.disable_status.rejected},
            {value: 3, label: '欠勤', disabled: jobApply.disable_status.not_work, style: {display: jobApply.is_houjin_job ? "" : "none"}},
            // {value: 9, label: '応募キャンセル', disabled: true},
        ];

        this.setState({statusOptions: options});
    }

    fireRedirect(e) {
        e.preventDefault()
        this.props.onHandleRedirect(e.currentTarget.getAttribute('href'));
    }

    /**
     * Call function save data from element parent
     */
    saveData() {
        let job = this.getData();
        //to top
        window.scrollTo(0, 0)
        if (job.hasOwnProperty('id')) {
            axios.post('/api/jobapplys/edit/' + job.id, job).then(response => {
                if (response.data.success) {
                    this.getJobApplyById();
                    toast.success(response.data.message)
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    /**
     * Call function cancel apply job from element parent
     */
    cancelApplyJob(){
        let job = this.getData();
        if (window.confirm('この応募をキャンセルしてもよろしいですか？')) {
            //to top
            window.scrollTo(0, 0)
            axios.get('/api/jobapplys/delete/' + job.id, job).then(response => {
                if (response.data.success) {
                    toast.success(response.data.message)
                    this.setData(response.data.jobApply);
                } else if (response.data.error) {
                    toast.error(response.data.message)
                    this.setData(response.data.jobApply);
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    /**
     * Call function destroy apply job from element parent
     */
    destroyJobApply(){
        let job = this.getData();
        axios.post('/api/jobapplys/delete/' + job.id, job).then(response => {
            if (response.data.success) {
                toast.success(response.data.message);
                this.setState({current_status: this.state.jobApply.status})
                this.setData(response.data.jobApply);
            } else if (response.data.error) {
                toast.error(response.data.message)
            } else {
                Object.keys(response.data.errors).map((key, i) => {
                        if($.isArray(response.data.errors[key])){
                            response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(response.data.errors[key])
                        }
                    }
                )
            }
        }).catch(error => {
            Object.keys(error.response.data.errors).map((key, i) => {
                    if($.isArray(error.response.data.errors[key])){
                        error.response.data.errors[key].map((child, i) => {
                            toast.error(child)
                        })
                    } else {
                        toast.error(error.response.data.errors[key])
                    }
                }
            )
        })
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    handleRenderDestroyJobApply() {
        if (this.state.jobApply.status == 1 && this.state.jobApply.cancel_apply_flag != 1) {
            return (
                <button onClick={this.destroyJobApply} className="btn btn-danger btn-radius btn-lg ml-1">
                    <span className="size-inherit">採用後キャンセル</span>
                </button>
            );
        }
        return;
    }
    renderApplyDates() {
        const job = this.state.jobApply.job
        const from = new Date(job.post_period_start_date);
        const to = new Date(job.post_period_end_date);

        return (
            <select
                onChange={this.handleInptChange}
                defaultValue={this.state.jobApply.apply_date_raw}
                disabled={this.state.isFinishedEvaluation}
                name="apply_date"
                className="form-control"
            >
                {(function () {
                    const list = [];
                    for (var d = from; d <= to; d.setDate(d.getDate() + 1)) {
                    let weekOfDay = '';
                    switch (d.getDay()) {
                        case 0:
                        weekOfDay = '(日)';
                        break;
                        case 1:
                        weekOfDay = '(月)';
                        break;
                        case 2:
                        weekOfDay = '(火)';
                        break;
                        case 3:
                        weekOfDay = '(水)';
                        break;
                        case 4:
                        weekOfDay = '(木)';
                        break;
                        case 5:
                        weekOfDay = '(金)';
                        break;
                        case 6:
                        weekOfDay = '(土)';
                        break;
                        default:
                        break;

                    }
                    const postDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
                    const labelDate = `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日${weekOfDay}`;
                    list.push(<option value={postDate} key={d}>{labelDate}</option>);
                    }
                    return <>{list}</>;
                }())}
            </select>
        );
    }

    render() {
        return (
            <React.Fragment>
            <div className="row">
                <div className="col-sm-12">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                            <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/jobapplys">応募一覧</a></li>
                            <li className="breadcrumb-item active" aria-current="page">応募編集</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <main id="main">
                <div className="row justify-content-md-center">
                    <div className="col-sm-6">
                        <div className="card">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">応募編集</h4></div>
                            <div className="card-body">
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">依頼者</label>
                                    <div className="col-sm-8">
                                        {(this.state.jobApply.client_first_last_name || (this.state.jobApply.client && this.state.jobApply.client.firstname && this.state.jobApply.client.lastname)) ?
                                        <label className="col-value text-left text-primary"><a href={this.state.jobApply.clientId ? "/accounts/edit/" + this.state.jobApply.clientId : this.state.jobApply.client.id}>{this.state.jobApply.client_first_last_name ? this.state.jobApply.client_first_last_name : this.state.jobApply.client.firstname+this.state.jobApply.client.lastname}</a></label>
                                        : ''}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">依頼ID</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left text-primary"><a href={"/jobs/edit/" + this.state.jobApply.job_id}>{this.state.jobApply.job_id}</a></label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">ワーカー</label>
                                    <div className="col-sm-8">
                                        {(this.state.jobApply.staffs_first_last_name || (this.state.jobApply.staff && this.state.jobApply.staff.firstname && this.state.jobApply.staff.lastname)) ?
                                        <label className="col-value text-left text-primary"><a href={this.state.jobApply.staffId ? "/accounts/edit/" + this.state.jobApply.account_id : this.state.jobApply.staff.id}>{this.state.jobApply.staffs_first_last_name ? this.state.jobApply.staffs_first_last_name : this.state.jobApply.staff.firstname+this.state.jobApply.staff.lastname}</a></label>
                                        : ''}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">ステータス</label>
                                    <div className="col-sm-8">
                                        <select
                                            onChange={this.handleInptChange}
                                            value={this.state.jobApply.status}
                                            disabled={this.state.isFinishedEvaluation}
                                            name="status"
                                            className="form-control"
                                        >
                                            {this.state.statusOptions.map((option, i) => {
                                                return <option key={i} value={option.value} disabled={option.disabled} style={option.style}>
                                                    {option.label}
                                                </option>;
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">依頼者への評価</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="job_applys.evaluation_client" value={this.state.jobApply.evaluation_client ? this.state.jobApply.evaluation_client : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">ワーカーへの評価</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="job_applys.evaluation_staff" value={this.state.jobApply.evaluation_staff ? this.state.jobApply.evaluation_staff : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">完了フラグ</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} is_disabled={true} element="job_applys.complete_flag" value={this.state.jobApply.complete_flag ? this.state.jobApply.complete_flag : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">勤務結果</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} is_disabled={true} element="job_applys.work_result" value={this.state.jobApply.work_result ? this.state.jobApply.work_result : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">報酬</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">¥{this.state.jobApply.reward_amount ? parseInt(this.state.jobApply.reward_amount).toLocaleString() : 0}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">契約形態</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.jobApply.payment_method_text}</label>
                                    </div>
                                </div>
                                {this.state.jobApply.job && this.state.jobApply.job.publication_type == 2 ? (
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">作業予定日</label>
                                    <div className="col-sm-8">
                                        {this.renderApplyDates()}
                                    </div>
                                    {/* <div className="col-sm-8">
                                        <label className="col-value text-left">{this.state.jobApply.apply_date}</label>
                                    </div> */}
                                </div>
                                ): ''}
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">応募日</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{moment(this.state.jobApply.created_at).format('YYYY-MM-DD HH:mm')}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">編集日</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{moment(this.state.jobApply.updated_at).format('YYYY-MM-DD HH:mm')}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">メモ</label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="remark" value={this.state.jobApply.remark ? this.state.jobApply.remark : ""}  className="form-control" rows="8"></textarea>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">採用後キャンセル</label>
                                    <div className="col-sm-8">
                                        <input type="checkbox" checked={this.state.jobApply.cancel_apply_flag} className="form-checkbox" disabled/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card-footer">
                                    <div className="text-center">
                                        <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg"><span className="size-inherit">保存する</span></button>
                                        {this.handleRenderDestroyJobApply()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <ToastContainer />
        </React.Fragment>
        )
    }
}
